/**
 * userinfo
 */
const privacyKey = 'yingqiyu_ziubao_shop_privacy';

export const setPrivacy = () => {
    localStorage.setItem(privacyKey, 1);
}

export const getPrivacy = () => {
    return localStorage.getItem(privacyKey);
}